import React, { useState, useEffect, Fragment } from 'react';
import {
    Row,
    Input,
    FormGroup,
    Label,
    CustomInput,
    Button,
    ButtonGroup,
    Form,
    Modal,
    ModalBody,
    InputGroup,
} from 'reactstrap';
import {
    Colxx,
    Separator,
} from '../../../../../../components/common/CustomBootstrap';

import { AxiosAPI, getGroupID } from '../../../../../../helpers/AxiosAPI';
import { sortPropertyListByName } from '../../../../../../helpers/Utils';
import {
    gAPI_Property_List_By_Group,
    API_SMS_INTEGRATION,
} from '../../../../../../constants/APIs';
import Validation from '../../../../../../components/Validation';
export default function SMSIntegration({ visible, toggle, id }) {
    const [property, setProperty] = useState([]);
    const [msg, setMsg] = useState([]);
    const [open, setOpen] = useState(false);
    const [inputData, setInputData] = useState({
        groupId: getGroupID(),
        name: '',
        defaultLanguage: 'en-US',
        sessionTimeoutInSeconds: 600,
        propertyId: '',
        phoneNumber: '',
        accountSID: '',
        authToken: '',
    });

    useEffect(() => {
        console.log("iiid", id)
        if (id !== undefined) {
            AxiosAPI({
                method: 'get',
                url: `${API_SMS_INTEGRATION}/${id}?group_id=${getGroupID()}`,
            })
                .then((res) => {
                    console.log("sssSMS", res.data)
                    setInputData({
                        ...inputData,
                        name: res.data.name,
                        properties: res.data.properties !== null ? res.data.properties : [],
                        phoneNumber: res.data.channelDetails.phoneNumber,
                        accountSID: res.data.channelDetails.accountSID,
                        authToken: res.data.channelDetails.authToken,
                    });
                })
                .catch((err) => console.log('err', err));

            AxiosAPI({
                method: 'get',
                url: `${gAPI_Property_List_By_Group}/?group_id=${getGroupID()}`,
            })
                .then((res) => {
                    setProperty([...res.data]);
                })
                .catch((err) => console.error(err));
        } else {
            AxiosAPI({
                method: 'get',
                url: `${gAPI_Property_List_By_Group}/?group_id=${getGroupID()}`,
            })
                .then((res) => {
                    setProperty([...res.data]);
                })
                .catch((err) => console.error(err));
        }
    }, [id]);

    const handleNameChange = (e) => {
        e.persist();
        setInputData({ ...inputData, name: e.target.value });
    };

    const handlePhoneNumberChange = (e) => {
        e.persist();
        setInputData({ ...inputData, phoneNumber: e.target.value });
        //console.log(inputData)
    };

    const handleAccountSIDChange = (e) => {
        e.persist();
        setInputData({ ...inputData, accountSID: e.target.value });
        //console.log(inputData)
    };
    const handleAuthTokenChange = (e) => {
        e.persist();
        setInputData({ ...inputData, authToken: e.target.value });
        //console.log(inputData)
    };

    const handleCheckChange = (e) => {
        if (e.target.checked) {
            setInputData({ ...inputData, propertyId: e.target.value });
        }
        if (!e.target.checked) {
            setInputData({ ...inputData, propertyId: '' });
        }
    };

    const handleSave = async () => {
        if (id !== undefined) {
            AxiosAPI({
                method: 'put',
                url: `${API_SMS_INTEGRATION}/${id}?group_id=${getGroupID()}`,
                data: inputData,
            }).then((res) => {
                if (
                    res.data.HttpStatusCode !== undefined &&
                    res.data.HttpStatusCode === 400 &&
                    res.data.Messages !== undefined &&
                    res.data.Messages !== null &&
                    res.data.Messages.length > 0
                ) {
                    setMsg(res.data.Messages);
                    setOpen(true);
                } else {
                    toggle();
                    setTimeout(() => {
                        window.location.reload();
                    }, 300);
                }
            });
        } else {
            AxiosAPI({
                method: 'post',
                url: API_SMS_INTEGRATION,
                data: inputData,
            }).then((res) => {
                if (
                    res.data.HttpStatusCode !== undefined &&
                    res.data.HttpStatusCode === 400 &&
                    res.data.Messages !== undefined &&
                    res.data.Messages !== null &&
                    res.data.Messages.length > 0
                ) {
                    setMsg(res.data.Messages);
                    setOpen(true);
                } else {
                    toggle();
                    setTimeout(() => {
                        window.location.reload();
                    }, 300);
                }
            });
        }
    };

    return (
        <Fragment>
            <Modal isOpen={visible} toggle={toggle}>
                <ModalBody>
                    <Row className="mb-4">
                        <Colxx xxs="12">
                            <div className="text-center">
                                <h6>
                                    {id === undefined ? 'Add' : 'Update'} SMS Integration
                                </h6>
                                <Separator className="mb-3" />
                                <Form>
                                    <FormGroup className="text-left mb-2">
                                        <Label>Integration Name</Label>
                                        <Input
                                            type="text"
                                            name="name"
                                            onChange={handleNameChange}
                                            placeholder="Integration Name"
                                            defaultValue={inputData.name}
                                        />
                                    </FormGroup>
                                    <FormGroup className="text-left mb-2">
                                        <Label>Phone Number</Label>
                                        <Input
                                            type="text"
                                            name="phoneNumber"
                                            onChange={handlePhoneNumberChange}
                                            placeholder="+[country code][area code][phone number]"
                                            defaultValue={inputData.phoneNumber}
                                        />
                                    </FormGroup>
                                    <FormGroup className="text-left mb-2">
                                        <Label>Account SID</Label>
                                        <Input
                                            type="text"
                                            name="accountSID"
                                            onChange={handleAccountSIDChange}
                                            placeholder="Account Sid can be found in your Twilio account settings"
                                            defaultValue={inputData.accountSID}
                                        />
                                    </FormGroup>
                                    <FormGroup className="text-left mb-2">
                                        <Label>Auth Token</Label>
                                        <Input
                                            type="text"
                                            name="authToken"
                                            onChange={handleAuthTokenChange}
                                            placeholder="Auth Token can be found in your Twilio account settings"
                                            defaultValue={inputData.authToken}
                                        />
                                    </FormGroup>
                                    <FormGroup className="mb-2">
                                        <div className="my-2 text-center">
                                            <h3>Select your property</h3>
                                        </div>
                                        <div className="integration-property">
                                            {sortPropertyListByName(property).map((p, index) => {
                                                return (
                                                    <CustomInput
                                                        key={p.id}
                                                        type="radio"
                                                        id={index}
                                                        label={p.name}
                                                        value={p.id}
                                                        name="property"
                                                        checked={
                                                            p.id === inputData.propertyId ? true : false
                                                        }
                                                        onChange={handleCheckChange}
                                                    />
                                                );
                                            })}
                                        </div>
                                    </FormGroup>
                                </Form>
                                <ButtonGroup className="mb-2" style={{ marginTop: '20px' }}>
                                    {id === undefined ? (
                                        <Button color="primary" size="xs" onClick={handleSave}>
                                            Create New Integration
                                        </Button>
                                    ) : (
                                        <Button color="primary" size="xs" onClick={handleSave}>
                                            Update Integration
                                        </Button>
                                    )}

                                    <Button size="xs" color="dark" outline onClick={toggle}>
                                        Cancel
                                    </Button>
                                </ButtonGroup>
                            </div>
                        </Colxx>
                    </Row>
                </ModalBody>
            </Modal>
            <Validation
                open={open}
                messages={msg}
                toggle={() => {
                    setOpen(!open);
                }}
            ></Validation>
        </Fragment>
    );
}
